<template>
  <a-modal
    ref="createModal"
    title="新建分配集"
    :width="900"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirmValidate"
    :confirmLoading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="commitdata"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :rules="rules"
      class="full-width"
    >
      <a-form-model-item label="分配集名称" prop="assignmentSetName">
        <a-input v-model="commitdata.assignmentSetName" />
      </a-form-model-item>
      <a-form-model-item label="分配集说明" prop="description">
        <a-textarea :auto-size="{ minRows: 3, maxRows: 5 }" v-model="commitdata.description" />
      </a-form-model-item >
    </a-form-model>
  </a-modal>
</template>

  <script>
// import { apiCreateShipmentForecast } from '@/api/scp/salesForecast/salesForecastWorkDesk'
import { apiNewMdmOrgSrAssignmentSets } from '@/api/mps/basic-data/product-distribution-ratio.js';

// 表单字段
export default {
  props: {
    uomClassOptions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      // 表单校验
      rules: {
        assignmentSetName: [{ required: true, message: '分配集名称不能为空', trigger: 'change' }]
      },
      commitdata: {
        assignmentSetName: '', // 预测名称
        description: ''
      },
      inputType: 1,
      // 状态数据字典
      // 当前控件配置:
      confirmLoading: false,
      visible: false
    }
  },
  created () {},
  methods: {
    handleForecastName (val, selectList) {
      this.commitdata.versionCode = ''
      this.commitdata.versionDescription = ''
      //     debugger
      //   const filteredItem = selectList.filter(item => item.realValue === val);
      //  this.commitdata.versionDescription = filteredItem[0].bringOutDataOne
    },
    handleVersionChange (val, selectList) {
      const filteredItem = selectList.filter((item) => item.realValue === val)
      this.commitdata.versionDescription = filteredItem[0].bringOutDataOne
    },
    handleRemove (file) {
      this.commitdata.fileList = []
    },
    beforeUpload (file) {
      this.$message.success('已添加文件')
      this.commitdata.fileList = [file]
      return false
    },
    show () {
      // this.addLine()
      this.visible = true
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    confirmValidate () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirm()
        }
      })
    },
    confirm () {
          this.confirmLoading = true
      apiNewMdmOrgSrAssignmentSets(this.commitdata).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.commitdata = {
        assignmentSetName: '', // 预测名称
        description: ''
      }
      this.typeList = []
    }
  }
}
</script>

  <style scoped lang="less">
/deep/.ant-select {
  width: 150px;
}
/deep/.ant-input {
  width: 220px;
}
/deep/.ant-modal-body {
  height: 400px;
  overflow-y: scroll;
}
.rp-width {
  width: 200px;
}
.ip-width {
  width: 150px;
}
.full-width {
  width: 100%;
}
.col-tips {
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4470588235294118);
  line-height: 22px;
}
</style>
